export default __webpack_public_path__ + "static/media/icone_sucesso.557fa3f0.svg";